import ReleasedDocumentsTable from '@/components/ReleasedDocumentsTable';
import { useUser } from '@/providers/UserProvider';
import {
  useReleasedDocuments,
  useReleasedDocumentsDownload,
} from '@/hooks/releases/useReleasedDocuments';

interface FinalDocumentsProps {
  submissionId: string;
}

/**
 * Submission-level Final Documents: what Univo released for this submission
 * specifically. Study-scoped releases belong to the study tab, which keeps the
 * two spaces disjoint rather than double-listing the same document.
 *
 * Read-only for every customer role — documents land here only when Ops seals a
 * release.
 */
const FinalDocuments = ({ submissionId }: FinalDocumentsProps) => {
  const { userData } = useUser();
  const { documents, isLoading, error } = useReleasedDocuments({
    scope: 'submission',
    id: submissionId,
  });
  const { download, isDownloading, downloadError, zipExportId } =
    useReleasedDocumentsDownload('submission', submissionId);

  return (
    <ReleasedDocumentsTable
      documents={documents}
      isLoading={isLoading}
      error={error}
      onDownload={download}
      isDownloading={isDownloading}
      downloadError={downloadError}
      zipExportId={zipExportId}
      userId={userData?.id}
    />
  );
};

export default FinalDocuments;
